// App
export const appCode = import.meta.env.VITE_APP_CODE;
export const appName = import.meta.env.VITE_APP_NAME;
export const appPrefix = import.meta.env.VITE_APP_PREFIX;
export const appVersion = import.meta.env.VITE_VERSION;
export const appClientId = import.meta.env.VITE_CLIENT_ID;
// API
export const apiBaseUrl = import.meta.env.VITE_API_URL;
export const apiKey = import.meta.env.VITE_API_KEY;
export const apiOS = import.meta.env.VITE_API_OS;
// Providers
export const googleMapApiKey = import.meta.env.VITE_GOOGLE_MAP_API_KEY;
export const facebookAppId = import.meta.env.VITE_FACEBOOK_APP_ID;
export const facebookAppVersion = import.meta.env.VITE_FACEBOOK_APP_VERSION;
export const googleClientId = import.meta.env.VITE_GOOGLE_CLIENT_ID;
// Environment
export const __DEV__ = import.meta.env.VITE_MODE === "development";
export const defaultLocaleCode = import.meta.env.VITE_DEFAULT_LOCALE_CODE;
export const fallbackLocaleCode = import.meta.env.VITE_DEFAULT_LOCALE_CODE;
export const maintenanceMode = import.meta.env.VITE_MAINTENANCE_MODE;
